import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { SubCategory } from '../types/sub-category.type';
import { ADMIN_SUB_CATEGORIES_API_PATHS } from '../constants/sub-categories-api-paths.constants';

type CreateSubCategoryData = {
  name: string;
  description: string;
  isActive: boolean;
  category: string;
};

type UseCreateSubCategoryResult = {
  createSubCategory: (data: CreateSubCategoryData) => Promise<SubCategory | null>;
  isSubmitting: boolean;
};

export function useCreateSubCategory(): UseCreateSubCategoryResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createSubCategory = async (data: CreateSubCategoryData): Promise<SubCategory | null> => {
    setIsSubmitting(true);

    try {
      const subCategory = await HttpClient.post<SubCategory>(ADMIN_SUB_CATEGORIES_API_PATHS.CREATE_SUB_CATEGORY, data);

      enqueueSnackbar('La sous-rubrique a été créée', { variant: 'success' });
      return subCategory;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la création de la sous-rubrique'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { createSubCategory, isSubmitting };
}
